import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/** Resolve a possibly-relative asset URL (e.g. /static/cars/x.png) to absolute. */
export const resolveAsset = (url) => {
  if (!url) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
};

const enrichCar = (c) => ({
  ...c,
  image: resolveAsset(c.image),
  gallery: (c.gallery || []).map(resolveAsset),
  panorama_url: resolveAsset(c.panorama_url),
});

const TOKEN_KEY = "movix_admin_token";

export const getAdminToken = () =>
  typeof window !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
export const setAdminToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const tok = getAdminToken();
  if (tok && config.url?.startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${tok}`;
  }
  if (tok && config.url === "/auth/me") {
    config.headers.Authorization = `Bearer ${tok}`;
  }
  return config;
});

export const fetchCars = (category) =>
  api.get(`/cars`, { params: category ? { category } : {} }).then((r) => r.data);

export const fetchCar = (carId) => api.get(`/cars/${carId}`).then((r) => r.data);

export const fetchCarAvailability = (carId) =>
  api.get(`/cars/${carId}/availability`).then((r) => r.data);

export const submitContact = (payload) =>
  api.post(`/contact`, payload).then((r) => r.data);

export const createReservationRequest = (payload) =>
  api.post(`/reservations/request`, payload).then((r) => r.data);

export const createCheckoutSession = (payload) =>
  api.post(`/checkout/session`, payload).then((r) => r.data);

export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);

export const checkReferral = (code) =>
  api.get(`/referrals/check/${encodeURIComponent(code)}`).then((r) => r.data);

export const generateReferral = (payload) =>
  api.post(`/referrals/generate`, payload).then((r) => r.data);

export const adminLogin = (email, password) =>
  api.post(`/auth/login`, { email, password }).then((r) => r.data);

export const adminMe = () => api.get(`/auth/me`).then((r) => r.data);

export const adminLogout = () => {
  clearAdminToken();
  return api.post(`/auth/logout`).then((r) => r.data).catch(() => ({ ok: true }));
};

export const adminStats = () => api.get(`/admin/stats`).then((r) => r.data);
export const adminReservations = (params = {}) =>
  api.get(`/admin/reservations`, { params }).then((r) => r.data);
export const adminReferrals = () =>
  api.get(`/admin/referrals`).then((r) => r.data);
export const adminContacts = () =>
  api.get(`/admin/contacts`).then((r) => r.data);
